import React, { Component } from 'react';
import Card from '../../ui/Card';
import { TrendingUpIcon, TargetIcon, ZapIcon, RocketIcon } from 'lucide-react';
const TopOpportunitiesPanel: React.FC = () => {
  const opportunities = [{
    rank: 1,
    category: 'Market Expansion',
    opportunity: 'EV Component Market Entry',
    potential: '₹285 Cr',
    probability: '75%',
    expectedValue: '₹214 Cr',
    timeline: '18-24 months',
    investment: '₹65 Cr',
    roi: '329%',
    owner: 'CSO',
    status: 'Under Evaluation',
    color: 'bg-green-100 border-green-300 text-green-800',
    icon: <RocketIcon size={18} data-id="element-3527" />
  }, {
    rank: 2,
    category: 'Operational',
    opportunity: 'Chennai Plant Efficiency Replication',
    potential: '₹142 Cr',
    probability: '85%',
    expectedValue: '₹121 Cr',
    timeline: '6-9 months',
    investment: '₹28 Cr',
    roi: '432%',
    owner: 'COO',
    status: 'In Progress',
    color: 'bg-green-100 border-green-300 text-green-800',
    icon: <ZapIcon size={18} data-id="element-3528" />
  }, {
    rank: 3,
    category: 'Product',
    opportunity: 'Premium Lighting Product Line',
    potential: '₹165 Cr',
    probability: '70%',
    expectedValue: '₹116 Cr',
    timeline: '12-15 months',
    investment: '₹42 Cr',
    roi: '276%',
    owner: 'Product Head',
    status: 'Planning',
    color: 'bg-blue-100 border-blue-300 text-blue-800',
    icon: <TargetIcon size={18} data-id="element-3529" />
  }, {
    rank: 4,
    category: 'Supply Chain',
    opportunity: 'Vendor Consolidation & Negotiation',
    potential: '₹95 Cr',
    probability: '90%',
    expectedValue: '₹86 Cr',
    timeline: '3-6 months',
    investment: '₹8 Cr',
    roi: '1075%',
    owner: 'SCM Head',
    status: 'Ready to Execute',
    color: 'bg-green-100 border-green-300 text-green-800',
    icon: <TrendingUpIcon size={18} data-id="element-3530" />
  }, {
    rank: 5,
    category: 'Geographic',
    opportunity: 'South Market Penetration',
    potential: '₹125 Cr',
    probability: '65%',
    expectedValue: '₹81 Cr',
    timeline: '12-18 months',
    investment: '₹35 Cr',
    roi: '231%',
    owner: 'Regional Head',
    status: 'Under Evaluation',
    color: 'bg-blue-100 border-blue-300 text-blue-800',
    icon: <TargetIcon size={18} data-id="element-3531" />
  }, {
    rank: 6,
    category: 'Technology',
    opportunity: 'Automation & Digitalization',
    potential: '₹108 Cr',
    probability: '80%',
    expectedValue: '₹86 Cr',
    timeline: '15-24 months',
    investment: '₹52 Cr',
    roi: '165%',
    owner: 'CIO',
    status: 'Planning',
    color: 'bg-blue-100 border-blue-300 text-blue-800',
    icon: <ZapIcon size={18} data-id="element-3532" />
  }, {
    rank: 7,
    category: 'Customer',
    opportunity: 'Aftermarket Revenue Enhancement',
    potential: '₹88 Cr',
    probability: '75%',
    expectedValue: '₹66 Cr',
    timeline: '9-12 months',
    investment: '₹18 Cr',
    roi: '367%',
    owner: 'Service Head',
    status: 'In Progress',
    color: 'bg-green-100 border-green-300 text-green-800',
    icon: <TrendingUpIcon size={18} data-id="element-3533" />
  }, {
    rank: 8,
    category: 'Product',
    opportunity: 'Safety Products Portfolio Expansion',
    potential: '₹72 Cr',
    probability: '70%',
    expectedValue: '₹50 Cr',
    timeline: '12-18 months',
    investment: '₹22 Cr',
    roi: '227%',
    owner: 'Product Head',
    status: 'Planning',
    color: 'bg-blue-100 border-blue-300 text-blue-800',
    icon: <TargetIcon size={18} data-id="element-3534" />
  }, {
    rank: 9,
    category: 'Operational',
    opportunity: 'Energy Cost Optimization',
    potential: '₹45 Cr',
    probability: '85%',
    expectedValue: '₹38 Cr',
    timeline: '6-12 months',
    investment: '₹15 Cr',
    roi: '253%',
    owner: 'Plant Heads',
    status: 'Ready to Execute',
    color: 'bg-green-100 border-green-300 text-green-800',
    icon: <ZapIcon size={18} data-id="element-3535" />
  }, {
    rank: 10,
    category: 'Financial',
    opportunity: 'Working Capital Optimization',
    potential: '₹125 Cr',
    probability: '80%',
    expectedValue: '₹100 Cr',
    timeline: '3-6 months',
    investment: '₹5 Cr',
    roi: '2000%',
    owner: 'CFO',
    status: 'In Progress',
    color: 'bg-green-100 border-green-300 text-green-800',
    icon: <TrendingUpIcon size={18} data-id="element-3536" />
  }];
  return <Card className="p-6 bg-gradient-to-br from-green-50 to-white border-2 border-green-100" data-id="element-3537">
      <div className="flex items-center justify-between mb-4" data-id="element-3538">
        <div data-id="element-3539">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-3540">
            Top 10 Opportunities
          </h3>
          <p className="text-sm text-gray-600" data-id="element-3541">
            Strategic growth and improvement initiatives
          </p>
        </div>
        <div className="text-right" data-id="element-3542">
          <div className="text-3xl font-bold text-green-600" data-id="element-3543">10</div>
          <div className="text-xs text-gray-600" data-id="element-3544">Active Opportunities</div>
        </div>
      </div>
      <div className="space-y-3 max-h-[600px] overflow-y-auto" data-id="element-3545">
        {opportunities.map((opp, index) => <div key={index} className={`${opp.color} border-2 rounded-lg p-4`} data-id="element-3546">
            <div className="flex items-start justify-between mb-2" data-id="element-3547">
              <div className="flex items-start flex-1" data-id="element-3548">
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-white/50 mr-3 font-bold text-sm" data-id="element-3549">
                  #{opp.rank}
                </div>
                <div className="flex-1" data-id="element-3550">
                  <div className="flex items-center mb-1" data-id="element-3551">
                    <span className="text-xs font-semibold px-2 py-0.5 bg-white/50 rounded mr-2" data-id="element-3552">
                      {opp.category}
                    </span>
                    <span className="text-xs font-bold" data-id="element-3553">{opp.status}</span>
                  </div>
                  <div className="font-bold text-sm mb-1" data-id="element-3554">
                    {opp.opportunity}
                  </div>
                  <div className="text-xs mb-2" data-id="element-3555">
                    <span className="font-semibold" data-id="element-3556">Potential:</span>{' '}
                    {opp.potential} |{' '}
                    <span className="font-semibold" data-id="element-3557">Expected Value:</span>{' '}
                    {opp.expectedValue} ({opp.probability})
                  </div>
                </div>
              </div>
              <div className="ml-2" data-id="element-3558">{opp.icon}</div>
            </div>
            <div className="pt-2 border-t border-current/20" data-id="element-3559">
              <div className="grid grid-cols-3 gap-2 text-xs mb-1" data-id="element-3560">
                <div data-id="element-3561">
                  <span className="font-semibold" data-id="element-3562">Investment:</span>{' '}
                  {opp.investment}
                </div>
                <div data-id="element-3563">
                  <span className="font-semibold" data-id="element-3564">ROI:</span> {opp.roi}
                </div>
                <div data-id="element-3565">
                  <span className="font-semibold" data-id="element-3566">Timeline:</span>{' '}
                  {opp.timeline}
                </div>
              </div>
              <div className="text-xs" data-id="element-3567">
                <span className="font-semibold" data-id="element-3568">Owner:</span> {opp.owner}
              </div>
            </div>
          </div>)}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-3569">
        <div className="grid grid-cols-4 gap-4 text-sm" data-id="element-3570">
          <div className="text-center" data-id="element-3571">
            <div className="text-gray-600" data-id="element-3572">Total Potential</div>
            <div className="text-xl font-bold text-green-600" data-id="element-3573">₹1,250 Cr</div>
          </div>
          <div className="text-center" data-id="element-3574">
            <div className="text-gray-600" data-id="element-3575">Expected Value</div>
            <div className="text-xl font-bold text-green-600" data-id="element-3576">₹958 Cr</div>
          </div>
          <div className="text-center" data-id="element-3577">
            <div className="text-gray-600" data-id="element-3578">Total Investment</div>
            <div className="text-xl font-bold text-blue-600" data-id="element-3579">₹290 Cr</div>
          </div>
          <div className="text-center" data-id="element-3580">
            <div className="text-gray-600" data-id="element-3581">Avg ROI</div>
            <div className="text-xl font-bold text-green-600" data-id="element-3582">530%</div>
          </div>
        </div>
      </div>
    </Card>;
};
export default TopOpportunitiesPanel;